import type { ApiInternshipId } from '#/api/types/ApiTypedId';
import type { ApiInternship } from '#/modules/listing/internships/api/types/ApiInternship';
import type { ApiUnpublishedInternship } from '#/modules/listing/internships/api/types/ApiUnpublishedInternship';
import { FetchEndpoint } from '#/utils/endpoint/FetchEndpoint';

type ApiResponse = {
  data: ApiInternship | ApiUnpublishedInternship;
};

function mapResponse(
  response: ApiResponse,
): ApiInternship | ApiUnpublishedInternship {
  return response.data;
}

const endpoint = new FetchEndpoint({
  urlFactory: (internshipId: ApiInternshipId) =>
    `/data/website/internships/${internshipId}`,
  mapResponse,
});

// Exports

export const listingApiIsomorphicFetchInternship =
  endpoint.createIsomorphicFetchFn();
